export default __webpack_public_path__ + "static/media/Logo-icon.57759883.svg";